//Basic app wide actions we want to share
import Cookies from 'js-cookie';
import Config from '../config/AppConfig';
import {Auth} from 'aws-amplify';
import jwtDecode from 'jwt-decode';

export const APP_ERROR = 'APP_ERROR';

//Basic CreateReducer...
export const createReducer = (initialState, handlers) => {
  return (state = initialState, action) => {
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action)
    } else {
      return state
    }
  }
}

export const requestStatus = {
  pending: 'pending',
  complete: 'complete',
  rejected: 'rejected',
};

export const setSession = async () => {
  const session = await Auth.currentSession();
  const jwtToken = session.getIdToken().getJwtToken();
  const refreshToken = session.getRefreshToken().getToken();
  const accessToken = session.getAccessToken().getJwtToken();
  const {email} = jwtDecode(jwtToken);
  Cookies.set('userSessionIdentifier', jwtToken, {
    expires: 1 / 24,
    domain: Config.COOKIE_DOMAIN,
  });
  Cookies.set('currentUserEmail', email, {domain: Config.COOKIE_DOMAIN});
  Cookies.set('refreshToken', refreshToken, {domain: Config.COOKIE_DOMAIN});
  Cookies.set('accessToken', accessToken, {domain: Config.COOKIE_DOMAIN});
};

export const trackGoogleTagManager = (event, location) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    location
  });
  return new Promise((resolve) => {
    setTimeout(resolve, 500); // give the trackers the opportunity to complete
  });
};

export const sizeSwitch = (count) => {
  switch (count) {
    case 2:
      return 48;
    case 3:
      return 29;
    case 4:
      return 19;
    default:
      return 100;
  }
};
